import React, { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  SvgIcon,
  Tooltip,
  Typography,
  makeStyles
} from '@material-ui/core';
import {
  Bell as BellIcon,
  Package as PackageIcon,
  MessageCircle as MessageIcon,
  Truck as TruckIcon
} from 'react-feather';
import { getNotifications } from 'src/actions/notificationsActions';
import axios from 'axios';
import moment from 'moment';

const iconsMap = {
  order_placed: PackageIcon,
  new_message: MessageIcon,
  item_shipped: TruckIcon
};

const useStyles = makeStyles(theme => ({
  popover: {
    width: 320
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  }
}));

function Notifications() {
  const classes = useStyles();
  const { notifications } = useSelector(state => state.notifications);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setAllNotificationAsRead();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setAllNotificationAsRead = () => {
    axios
      .post('/api/ebpls/notifications/set-asread-users-notification')
      .then(({ data }) => {
        if (data.message === 'success') {
          dispatch(getNotifications());
        }
      });
  };

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  const unreadNotifications = notifications.filter(
    notification => notification.is_view === 0
  );

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <Badge color={'error'} badgeContent={unreadNotifications.length}>
            <SvgIcon>
              <BellIcon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        classes={{ paper: classes.popover }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        PaperProps={{
          style: {
            paddingBottom: '24px'
          }
        }}
      >
        <Box p={2}>
          <Typography variant="h5" color="textPrimary">
            Notifications
          </Typography>
        </Box>
        {notifications.length === 0 ? (
          <Box p={2}>
            <Typography variant="h6" color="textPrimary">
              There are no notifications
            </Typography>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                maxHeight: '400px',
                overflowX: 'auto'
              }}
            >
              <List className={classes.list} disablePadding>
                {notifications.map(notification => {
                  const Icon = iconsMap['new_message'];

                  return (
                    <ListItem
                      className={classes.listItem}
                      component={RouterLink}
                      divider
                      key={notification.id}
                      to="#"
                    >
                      <ListItemAvatar>
                        <Avatar className={classes.icon}>
                          <SvgIcon fontSize="small">
                            <Icon />
                          </SvgIcon>
                        </Avatar>
                      </ListItemAvatar>

                      <ListItemText
                        primary={notification.message}
                        primaryTypographyProps={{
                          variant: 'subtitle2',
                          color: 'textPrimary'
                        }}
                        secondary={moment(notification.created_at).format(
                          'MMM DD, YYYY'
                        )}
                        secondaryTypographyProps={{
                          variant: 'caption',
                          color: 'textPrimary'
                        }}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Box>

            {/* <Box p={1} display="flex" justifyContent="center">
              <Button onClick={() => setAllNotificationAsRead()}>
                Mark all as read
              </Button>
            </Box> */}
          </>
        )}
      </Popover>
    </>
  );
}

export default Notifications;
